import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Typography, Modal, Space } from "antd";
import type { FormProps } from "antd";
import * as auth from '../redux/actions'
import { UserOutlined, LockOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import "./login.css";
import { isEmpty } from "lodash";
import { ISettingTypeState } from "../../siteSettings/components/settings";
import { useDispatch, useSelector } from "react-redux";
import { imageBaseUrl } from "src/cms/helpers/constants";
import { useFingerprint } from "src/cms/layout/core/FingerPrintProvider";
import { IAuthState } from "../redux/reducer";
import { IErrorState } from "../../errors/redux/reducer";
import { useHistory } from "react-router-dom";

const { Title, Text } = Typography;

type LoginFormValues = {
  username: string;
  password: string;
  force_logout?: boolean;
};

const InstantLogin: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState<boolean>(false);
  const [errorModalVisible, setErrorModalVisible] = useState<boolean>(false);
  const [loginCredential, setLoginCredential] = useState<any>({ username: '', password: "", force_logout: false });
  const { fingerprint, loading: fingerprintLoading } = useFingerprint();
  const authResp: IAuthState = useSelector((state: any) => state.auth)
  const errorState: IErrorState = useSelector((state: any) => state.globalError)
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  const onFinish: FormProps<LoginFormValues>["onFinish"] = async (values) => {
    const { username, password, force_logout } = values
    setLoginCredential({ ...loginCredential, username, password });
    setLoading(true);
    dispatch(auth.actions.instantLogin(btoa(username), btoa(password), force_logout))

  };

  // Handle the response after dispatch finishes
  useEffect(() => {
    if (!authResp?.loading && loading) {
      setLoading(false);
      // Check if login was successful (accessToken exists)
      if (authResp?.is2FALogin) {
        // Success: redirect to OTP verification
        history.push({ pathname: '/auth/instant-verify-otp', state: { email: loginCredential?.username } });
      }
      // Check if there's an error
      else if (errorState?.errorMessage) {
        // Error: show modal
        setErrorModalVisible(true);
      }
    }
  }, [authResp, authResp?.is2FALogin, errorState?.errorMessage])

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="header-section">
          <img src={`${imageBaseUrl}/${logo}` || `/media/logos/global-ime-logo-svg.jpg`} alt="Bank Logo" className="bank-logo" />
          <Title level={3} className="login-title">
            Sign in to your account
          </Title>
          <Text type="secondary">Enter your credentials below</Text>
        </div>

        <Form<LoginFormValues>
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ remember: true }}
          requiredMark={false}
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please enter username" }]}
          >
            <Input
              prefix={<UserOutlined />}
              size="large"
              placeholder="Enter username"
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              size="large"
              placeholder="Enter password"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
            className="login-btn"
          >
            Login
          </Button>
        </Form>
      </div>

      {/* Error Modal */}
      <Modal
        centered
        open={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
        footer={null}
        width={420}
        closable
      >
        <div style={{ textAlign: 'center', padding: '10px 5px' }}>
          {/* Icon */}
          <ExclamationCircleOutlined
            style={{
              fontSize: 48,
              color: '#ff4d4f',
              marginBottom: 16,
            }}
          />

          {/* Title */}
          <h2 style={{ marginBottom: 8 }}>Login Failed</h2>

          {/* Message */}
          <p style={{ color: '#595959', marginBottom: 24 }}>
            {errorState?.errorMessage ||
              'We were unable to log you in. Please check your credentials and try again.'}
          </p>

          {/* Action Buttons */}
          <Space size="middle">
            <Button onClick={() => setErrorModalVisible(false)}>
              Cancel
            </Button>

            <Button
              type="primary"
              danger
              onClick={() =>
                onFinish({ ...loginCredential, force_logout: true })
              }
            >
              Force Login
            </Button>
          </Space>
        </div>
      </Modal>


      {/* <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />
            Login Error
          </span>
        }
        open={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => onFinish({ ...loginCredential, force_logout: true })}>
            OK
          </Button>
        ]}
      >
        <p>{errorState?.errorMessage || 'An error occurred during login. Please try again.'}</p>
      </Modal> */}
    </div>
  );
};

export default InstantLogin;


